// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__cg-8U","loaderOuter":"PageOverlayLoader_loaderOuter__38aF9"};